const InfoLinkIcon = ({ ...props }) => {
  return (
    <svg width="35" height="35" {...props}>
      <circle cx="17.5" cy="17.5" r="17.5" fill="#403197" />
      <text
        x="50%"
        y="50%"
        textAnchor="middle"
        fill="white"
        fontSize="16px"
        fontFamily="Lato"
        dy=".3em"
      >
        ?
      </text>
      ?
    </svg>
  )
}

export default InfoLinkIcon
